import { Component, Fragment } from 'react'

import emitter from 'garden/src/js/utils/emitter'

import * as shipmentsRepository from 'scripts/api/my-orders/carrier-tracking'

import { Drawer } from 'reactShared/components/Drawer'

import { showSpinner, hideSpinner } from 'reactUtils/Spinner'

class LastMile extends Component {
  constructor (props) {
    super(props)

    this.state = {
      forecast: [],
      isDrawerOpen: false,
      orderId: '',
      loading: true
    }
  }

  componentDidMount () {
    emitter.on('tracking:get-shipping', this.handlerButton)
  }

  toggleDrawer = (list, orderId) => {
    showSpinner()

    this.setState(prevState => ({
      forecast: list || [],
      isDrawerOpen: !prevState.isDrawerOpen,
      orderId
    }))
    hideSpinner()
  }

  getShipping (orderId, shipmentId) {
    return shipmentsRepository.find(orderId, shipmentId)
  }

  handlerButton = async ({ shipmentId, orderId }) => {
    showSpinner()

    try {
      const list = await this.getShipping(orderId, shipmentId)
      this.toggleDrawer(list, orderId)
    } catch (err) {
      this.showFetchError(err)
    }
    hideSpinner()
  }

  showFetchError = (error) => {
    hideSpinner()

    emitter.emit('stickyFeedback:error', {
      title: 'Ops! Ocorreu o seguinte erro:',
      content: 'Não foi possível rastrear seu pedido. Tente novamente mais tarde.'
    })

    console.error('Erro ao tentar rastrear pedidos', error)
  }

  render () {
    const { forecast, orderId } = this.state
    const expectedDeliveryDate = forecast.expectedDeliveryDate && forecast.expectedDeliveryDate.date

    return (
      <Fragment>
        <Drawer
          isOpen={this.state.isDrawerOpen}
          overlayClick={() => this.toggleDrawer(null)}
          className="shipping-tracking"
        >
          <div>
            <h2 className="order-tracking-title">
              <button aria-label="Fechar" className="glyph glyph-x close-button" onClick={() => this.toggleDrawer(null)} />
              Acompanhe seu pedido
            </h2>

            <div className="order-tracking-content">
              <h4 className="order-number">Pedido {orderId}</h4>
              <span className="small color-primary"> Entrega em domicílio - Previsão de Entrega {expectedDeliveryDate}</span>

              <h4 className="order-info"><strong>Informações do envio</strong></h4>
              <span className="small color-default">Dados fornecidos pela transportadora <strong>{forecast.carrierName}</strong></span>

              {!forecast.messages &&
                <p className="small color-danger">Ainda não temos as informações da transportadora. Tente mais tarde.</p>
              }

              {forecast.messages &&
                <table className="table table-zebra table-bordered margin-top">
                  <thead>
                    <tr>
                      <td>
                        <span className="color-primary">
                          <strong>Data</strong>
                        </span>
                      </td>
                      <td>
                        <span className="color-primary">
                          <strong>Status</strong>
                        </span>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      forecast.messages.map(({ date, message }, idx) => (
                        <tr key={`banner-${idx}`}>
                          <td>
                            <span className="color-primary small">
                              { date }
                            </span>
                          </td>
                          <td>
                            <span className="small">
                              { message }
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              }
            </div>
          </div>
        </Drawer>
      </Fragment>
    )
  }
}

export default LastMile
